import { render, staticRenderFns } from "./card-hsia-text-with-icon.vue?vue&type=template&id=73f6a8a1&scoped=true&"
import script from "./card-hsia-text-with-icon.vue?vue&type=script&lang=js&"
export * from "./card-hsia-text-with-icon.vue?vue&type=script&lang=js&"
import style0 from "./card-hsia-text-with-icon.vue?vue&type=style&index=0&id=73f6a8a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f6a8a1",
  null
  
)

export default component.exports